import Stepper from "../components/organisms/Stepper";
import {BackButton} from "../../../ui/button/BackButton";
import { Article } from '../../../ui/atoms/Article';
import { Container } from '../../../ui/atoms/Container';
const Devis = () => {
    
    return (
        <Article className="bg-slate-50 lg:h-screen min-h-screen  lg:pt-32 pt-24 flex items-stretch justify-center ">
            <Container className="lg:max-w-4xl flex items-center justify-center relative">
                <Stepper />
                <BackButton isRelative={false} />
            </Container>
            
        </Article>
    );
};

export default Devis;
